import type React from 'react'
import { createElement } from 'react'

/** Syntax-highlight a single line of G-code, returning a React node */
export function highlightGCode(line: string): React.ReactNode {
  if (!line.trim()) return createElement('span', null, '\u00A0')

  if (line.trim().startsWith(';') || line.trim().startsWith('(')) {
    return createElement('span', { className: 'text-emerald-600 italic' }, line)
  }

  const parts: React.ReactNode[] = []
  let remaining = line
  let key = 0

  const addToken = (text: string, className: string) => {
    parts.push(createElement('span', { key: key++, className }, text))
  }

  while (remaining.length > 0) {
    const nMatch = remaining.match(/^(N\d+)/)
    if (nMatch) {
      addToken(nMatch[1], 'text-slate-600')
      remaining = remaining.slice(nMatch[1].length)
      continue
    }

    const gmMatch = remaining.match(/^([GM]\d+(?:\.\d+)?)/)
    if (gmMatch) {
      addToken(gmMatch[1], 'text-cyan-400 font-semibold')
      remaining = remaining.slice(gmMatch[1].length)
      continue
    }

    const coordMatch = remaining.match(/^([XYZFIJKRHTS])(-?\d+(?:\.\d+)?)/)
    if (coordMatch) {
      addToken(coordMatch[1], 'text-green-400')
      addToken(coordMatch[2], 'text-orange-400')
      remaining = remaining.slice(coordMatch[0].length)
      continue
    }

    const numMatch = remaining.match(/^(-?\d+(?:\.\d+)?)/)
    if (numMatch) {
      addToken(numMatch[1], 'text-orange-400')
      remaining = remaining.slice(numMatch[1].length)
      continue
    }

    const parenMatch = remaining.match(/^(\([^)]*\))/)
    if (parenMatch) {
      addToken(parenMatch[1], 'text-emerald-600 italic')
      remaining = remaining.slice(parenMatch[1].length)
      continue
    }

    const oMatch = remaining.match(/^(O\d+)/)
    if (oMatch) {
      addToken(oMatch[1], 'text-purple-400 font-semibold')
      remaining = remaining.slice(oMatch[1].length)
      continue
    }

    addToken(remaining[0], 'text-slate-400')
    remaining = remaining.slice(1)
  }

  return createElement('span', null, ...parts)
}
